import humanizeDuration from "humanize-duration";

const gl = {
  y: function(c) {
    return "ano" + (c === 1 ? "" : "s");
  },
  mo: function(c) {
    return "mes" + (c === 1 ? "" : "es");
  },
  w: function(c) {
    return "semana" + (c === 1 ? "" : "s");
  },
  d: function(c) {
    return "día" + (c === 1 ? "" : "s");
  },
  h: function(c) {
    return "hora" + (c === 1 ? "" : "s");
  },
  m: function(c) {
    return "minuto" + (c === 1 ? "" : "s");
  },
  s: function(c) {
    return "segundo" + (c === 1 ? "" : "s");
  },
  ms: function(c) {
    return "milisegundo" + (c === 1 ? "" : "s");
  },
  decimal: ",",
};

export default locale => {
  const humanizer = humanizeDuration.humanizer({
    language: locale,
    fallbacks: ["es"],
    largest: 2,
    units: ["d", "h", "m"],
    round: true,
  });

  humanizer.languages = {
    ...humanizer.languages,
    gl,
  };

  return humanizer;
};
